module.exports = __webpack_public_path__ + "static/media/home_icon.836e691c.svg";